export default __webpack_public_path__ + "static/media/question-circle.79c65b5d.svg";